import {Module, Mutation, VuexModule} from 'vuex-module-decorators';

export enum SaveState {
  Idle,
  Initialize,
  Save,
  Connect,
  Restore,
  Finalize,
}

@Module({name: 'NetworkSafeUpdateStore', namespaced: true})
export default class NetworkSafeUpdateStore extends VuexModule {
  private saveState: SaveState = SaveState.Idle;

  private host: string = '';

  private timeout: number = 30;

  private timer: number = 0;

  get Open(): boolean {
    return this.SaveState !== SaveState.Idle;
  }

  @Mutation
  public setSaveState(state: SaveState) {
    this.saveState = state;
  }

  get SaveState(): SaveState {
    return this.saveState;
  }

  @Mutation
  public setHost(host: string) {
    this.host = host;
  }

  get Host(): string {
    return this.host;
  }

  @Mutation
  public setTimeout(value: number) {
    this.timeout = value;
  }

  get Timeout(): number {
    return this.timeout;
  }

  @Mutation
  public setTimer(value: number) {
    this.timer = value;
  }

  @Mutation
  public incrementTimer(by: number = 1) {
    this.timer += by;
  }

  get Timer(): number {
    return this.timer;
  }

  get TimeoutProgression(): number {
    return this.Timer / this.Timeout * 100;
  }

  get Countdown() {
    return Math.max(0, this.Timeout - this.Timer);
  }
}
